export default "__VITE_ASSET__b8567a43__"